import ImagePlaceholder from '@assets/icons/orderable-image-placeholder.svg';
import React, { useState } from 'react';
import { CatalogCategoryType } from '@/contexts/item-context-types';
import { Image, ImageStyle, StyleProp } from 'react-native';

interface Props {
  category: CatalogCategoryType;
  imageSize: number;
  style?: StyleProp<ImageStyle>;
}

export const CategoryImage: React.FC<Props> = ({
  category,
  imageSize,
  style,
}) => {
  const [hasError, setHasError] = useState(false);

  return hasError || !category.imageUrl ? (
    <ImagePlaceholder height={imageSize} width={imageSize} />
  ) : (
    <Image
      alt={category.name ?? ''}
      onError={() => {
        setHasError(true);
      }}
      resizeMode="cover"
      source={{
        uri: category.imageUrl,
      }}
      style={style}
      testID="supplier-catalog-category-image"
    />
  );
};
